import { Gauge, Globe2, Truck, UsersRound } from 'lucide-react'
import { useLocale } from '../context/LocaleContext'

export function ImpactRail() {
  const { content } = useLocale()
  const { ui } = content
  const items = [
    { value: '2M+', label: ui.impactUsers, icon: UsersRound },
    { value: '20', label: ui.impactMarkets, icon: Globe2 },
    { value: '6K', label: ui.impactDrivers, icon: Truck },
    { value: '>99.9%', label: ui.impactStability, icon: Gauge },
  ]
  return (
    <section className="impact section-shell" id="impact">
      <div className="impact-grid">
        {items.map(({ value, label, icon: Icon }) => (
          <article key={label} className="impact-item"><Icon aria-hidden="true" /><strong>{value}</strong><span>{label}</span></article>
        ))}
      </div>
    </section>
  )
}
